import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import TranCatForm from '../TranCatForm';
import { FlexDiv, WideBox } from '../../styles/styles';

const NewTransactionCategory = () => {
  const history = useHistory();
  const { authStore, dataStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const accounts = dataStore.validAccountArray;

  useEffect(() => {
    const initialize = async () => {
      if (accounts.length === 0) {
        await dataStore.retrieveAccounts();
      }
      setLoading(false);
    };
    initialize();
  }, []);

  if (isLoading) return <Spinner />;
  return (
    <FlexDiv>
      <WideBox showoverflow={1}>
        <TranCatForm
          onSubmit={async (values, actions) => {
            try {
              Object.keys(values).forEach(key => {
                if (values[key] === '' || values[key] === 'null') {
                  values[key] = null;
                }
              });
              await authStore.request.post(
                `${process.env.REACT_APP_API}/api/transaction-categories`,
                {
                  ...values,
                },
              );
              await dataStore.retrieveTransactionCategories();
              history.push('/transaction-categories');
            } catch (e) {
              console.error(e);
              actions.setSubmitting(false);
            }
          }}
        />
      </WideBox>
    </FlexDiv>
  );
};

export default NewTransactionCategory;
